/** Actual engine stages. Counts describe work within a stage, never total elapsed time. */
export type TraceStage = 'decoding' | 'coverage' | 'contours' | 'fitting' | 'validating' | 'refining' | 'tracing';
export type TraceProgress = { stage: TraceStage; completed?: number; total?: number };

const stages: readonly string[] = ['decoding', 'coverage', 'contours', 'fitting', 'validating', 'refining', 'tracing'];

/** Worker messages cross a runtime boundary; ignore malformed progress without ending the job. */
export function isTraceProgress(value: unknown): value is TraceProgress {
  if (!value || typeof value !== 'object') return false;
  const item = value as Partial<TraceProgress>;
  return stages.includes(item.stage ?? '')
    && (item.completed === undefined || Number.isSafeInteger(item.completed) && item.completed >= 0)
    && (item.total === undefined || Number.isSafeInteger(item.total) && item.total > 0)
    && (item.completed === undefined || item.total === undefined || item.completed <= item.total);
}
